"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangeMessage = void 0;

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getRangeMessage = function getRangeMessage(range) {
  if (range.minimum === range.maximum) {
    return _messages["default"].rangeExactly;
  } else if (range.maximum) {
    if (range.increment) {
      return _messages["default"].rangeMaximumWithIncrement;
    } else {
      return _messages["default"].rangeMaximumNoIncrement;
    }
  } else {
    if (range.increment) {
      return _messages["default"].rangeNoMaximumWithIncrement;
    } else {
      return _messages["default"].rangeNoMaximumNoIncrement;
    }
  }
};

exports.getRangeMessage = getRangeMessage;